import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/category/football', label: '足球资讯' },
    { to: '/category/basketball', label: '篮球资讯' },
    { to: '/category/tennis', label: '网球资讯' },
    { to: '/category/esports', label: '电竞资讯' },
    { to: '/category/comprehensive', label: '综合体育' },
    { to: '/about', label: t('nav.about') },
  ];

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-football-line text-lg text-background-50"></i>
              </span>
              <span className="text-xl font-bold font-heading text-background-50">
                {t('site.name')}
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              {t('site.description')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <div className="grid grid-cols-2 gap-2">
              {quickLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('footer.contact')}</h4>
            <div className="space-y-2 text-sm text-background-400">
              <p>邮箱：contact@kaiyunsports.com</p>
              <p>电话：400-888-6666</p>
              <p>地址：中国上海市浦东新区体育产业园区</p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">{t('footer.copyright')}</p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">
              {t('footer.terms')}
            </Link>
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">
              {t('footer.privacy')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}